<template>
	<div class="qualityenterprise">
		<leftnav class="fl" mkcode="E" itemcode="A-QBNZQY" docutitle="乡情招商"></leftnav>
		<div class="index_left" :style="isCollapse?'margin-left: 0;width:100%':''">
			<govheader></govheader>
			<el-dialog class="localChain" title="" :visible.sync="isShowFreeUserTips" width="650px" top="25vh">
				<freeUserTips :type="3" :bgtype="0"></freeUserTips>
			</el-dialog>
			<div class="index_left_centerpage">
				<div class="whitebox right_topbox" style="padding-bottom: 1px;">
					<div class="right_boxtitle map_title_tab">
						<span class="title" v-show="userdata.city>0" @click="handlerPageType(1)" :class="pageType == 1?'current':''">本市乡贤</span>
						<span class="title" @click="handlerPageType(2)" :class="pageType == 2?'current':''">本省乡贤</span>
						
						<!-- <div class="fr search-box nz-search-box">
							<span class="searchtype">产业图谱库</span>
							<input type="text" placeholder="请输入产业关键词" class="search-input" v-model="searchtext"	@keydown="searchenter" />
							<button class="search-btn" @click="searchkwfun">查询</button>
						</div> -->
					</div>  
					<div class="opport-screen-list1">
						<dl class="opport-screen bdbe">
							<dt class="fl">分类</dt>
							<dd class="fl">
								<!-- <span :class="classValue == 0?'a-screen current' : 'a-screen'" @click="citychoose({areaId:0,areaName:'全部'},2)">全部</span> -->
								<span :class="classValue == item.value?'a-screen current' : 'a-screen'" v-for="item in classList" :key="item.value" @click="handlerClassValue(item.value)">{{item.name}}</span>
							</dd>
						</dl>
						<dl class="opport-screen bdbe" v-show="citydata.length>0">
							<dt class="fl">本市城市</dt>
							<dd class="fl">
								<span :class="cityid == 0?'a-screen current' : 'a-screen'" @click="citychoose({areaId:0,areaName:'全部'},2)">全部</span>
								<span :class="cityid == item.areaId?'a-screen current' : 'a-screen'" v-for="item in citydata" :key="item.areaId" @click="citychoose(item,2)">{{item.areaName}}</span>
							</dd>
						</dl>
						<dl class="opport-screen bdbe" v-show="countydata.length>0">
							<dt class="fl">本市城区</dt>
							<dd class="fl">
								<span :class="countyid == 0?'a-screen current' : 'a-screen'" @click="citychoose({areaId:0,areaName:'全部'},3)">全部</span>
								<span :class="countyid == item.areaId?'a-screen current' : 'a-screen'" v-for="item in countydata" :key="item.areaId" @click="citychoose(item,3)">{{item.areaName}}</span>
							</dd>
						</dl>

                        <cityScreen @getEnterpriseList="cityScreenFun" provinceName="目标省市" cityName="目标城区" countyName="目标区县"></cityScreen>

						<!-- 产业概念细分筛选 -->
						<notionScreen 
						:type="2"  
						:notionNumberList="notionNumList"  
						:refreshNum="notionNumRefresh"
						:token="userdata.token" 
						@chooseNotion="chooseNotion" 
						:isShowNotionScreen="true"
						:isClearNotion="isClearNotion"
						:showNotionExtend="userdata.zsdn_version == 2"
						:showSimpleNotion="userdata.zsdn_version == 1"
						:isIntegration="isIntegration" 
						:isShowFutureIndustries="true"
						:ucomputer ="ucomputer"
						:isStickySimpleNoting="true"
						></notionScreen>
					</div>
				</div>

				<div class="whitebox" style="min-height: 160px;">
					<div class="enterparise_guide oh" style="width: 95%; ">
						<p class="fl" v-if="!kwtextsearch">产业大脑为您找到<span class="searchnum">{{total}}</span>条相关结果</p>
						<p class="fl" v-if="kwtextsearch">产业大脑为您找到<span class="searchnum">{{total}}</span>条【 <span
								class="orangefont">{{kwtextsearchtext}}</span>】相关结果</p>
                    </div>
					<div class="enterprise_list_box" v-show="enterpristlist.length!=0">
						<!-- 全部内资企业 -->
						<table border="0" cellspacing="0" cellpadding="0" class="enterprise_table">
							<tr>
								<th>乡贤姓名</th>
								<th>籍贯省份</th>
								<th>籍贯城市</th>
								<th>籍贯县市区</th>
								<th>担任职位</th>
								<th>所在企业</th>
								<th>企业标签</th>
								<th>企业所在城区  </th>
								<th>企业电话 </th>
								<th>详情</th>
							</tr>
							<tr :key="i" v-for="(list,i) in enterpristlist">
								<td>{{list.name}}</td>
                                <td>{{list.provinceText}}</td>
                                <td>{{list.cityText}}</td>
                                <td>{{list.countyText || '-'}}</td>
                                <td>{{list.position}}</td>
                                <td class="title" @click="routerblank('/enterprises?id='+list.stockCode)">{{list.company}}</td>
                                <td class="conpanytags notiontags" style="max-width: 350px;">
									<span class="span-tag" :key="index" v-for="(item,index) in list.taglist"
										@click="tagrouter('/enterpriseTag',0,'tag',item.id,item.name)">{{item.name}}</span>
								</td>
								<td>{{list.entProvinceText}} </br>{{list.entCityText}}</td>
								<td>{{list.phone}}</td>
								<td class="collectfont1" @click="routerblank('/enterprises?id='+list.stockCode)">
									<span>查看详情 ></span>
                                    
								</td>
							</tr>
						</table>
						<p v-if="freeTips" @click="isShowFreeUserTips = true" class="text-center gray-font" style="margin: 20px 0;"><span>——</span> 查看更多 <i class="el-icon-lock font18"></i> <span>——</span></p>
					</div>
					<div class="centerpage1 company_pagelist" v-show="totalPage>1">
						<zpagenav v-bind:page="page" v-bind:page-size="pageSize" v-bind:total="total"
							v-bind:max-page="maxPage" v-on:pagehandler="pageHandler"></zpagenav>
					</div>
				</div>
			</div>
		</div>
		<iframe :src='iframeurl' style="width: 1px;height: 1px;" frameborder="none" id="exportIframe"></iframe>
	</div>
</template>

<script>
	import { dataInJs } from "@/utils/city.js";
	import { mapState, mapMutations, mapGetters } from "vuex";
	
	export default {
		name: 'enterpriseList',
		computed: {
		...mapState({
		isCollapse: (state) => state.isCollapse,
		}),
		...mapGetters(['isCollapse'])
		},
		data() {
			return {
				curWebsite:this.$api.getWebsiteType(),
				title: "全部内资企业",
				searchPlaceholder: '请输入企业名称',
				curindex: 6,
				userdata: {token:''},
				notionCode: 0,
				chooseNotionlist: [0, 0, 0, 0, 0],
				searchtype: 0,
				searchtext: "",
				kwtextsearch: false,
				kwtextsearchtext: "", 
				notionNumRefresh:1,
				isClearNotion:false,
				notionNumList:[],
				page: 1, //显示的是哪一页
				haspage: true, //是否还有下一页
				pageSize: 10, //每一页显示的数据条数
				total: 0, //记录总数
				totalPage: 1,
				maxPage: 10, //最大页数 
				provinceid: 0,
				cityid: 0,
				countyid: 0, 
				citydata: [],
				countydata: [],
				fontb: {
					fontWeight: 'bold'
				},
				initialTagdata: [{
					tagName: "",
					tagCode: "",
					children: []
				}],
				qyslitagCom: [], //公共科技实力
				qyslitagPublicselect: [], //公共科技实力下拉框版
				comSearchdata: [0, 'empty', 'empty', 'empty'], //公共科技实力下拉框版 存储值
				qysltagUnique: [], //独有企业实力（全部内资企业集合 上市公司和优质企业的企业实力） 
				totalqysl:[],
				financing_rounds:[],//融资轮次标签
				investRound:'',//融资轮次
				totalqysl_shangshi: [ ],
				totalqysl_youzhi: [ ],
				searchtagdata: ['0'],
				enterpristlist: [],
				usertaglist: [],
				num: 0,
				orderField: 0, //排序字段 0 分数 1 时间
				ordertype: 0, //排序方式 0 降序 1 升序   
				commontagcode: 0,
				tyinitialTagdata: [],
				exportnum: 0, //导出次数
				exportpop: false, //点击导出按钮弹框显示
				allowexport: false, //后台判断是否可以上传
				exportbtn: true, //loading小 等待转圈圈
				confirmtext: '确认导出',
				iframeurl: '',
				notionstep: 0,
				// 0=分数,1=融资时间,2=企业实力,3=投资力度,4=本省关联度,5=拿地数量,6=拿地面积,7=拿地金额,8=投资项目数量,9=投资项目金额,10=控制企业数量,11=专利数量
				dimensionList: [{
					name: '综合',
					type: 0
				}, {
					name: '拿地数量',
					type: 5
				}, {
					name: '拿地面积',
					type: 6
				}, {
					name: '拿地金额',
					type: 7
				}, {
					name: '投资项目数量',
					type: 8
				}, {
					name: '投资项目金额',
					type: 9
				}, {
					name: '控制企业',
					type: 10
				}, ],
				isIntegration:true,
				ucomputer:false, //不计算概念数量，港股和美股暂无数据所以不计算
				showTipsType:3,
				isShowFreeUserTips:false,
                pageType:1,
				targetcityid:'',
				targetcountyid	:'',
				targetprovinceid:'',
				freeTips:true,
				classList:[
					{value:1,name:'商界'},
					{value:2,name:'学界'},
					{value:3,name:'政界'},
					{value:4,name:'工界'}
				],
				classValue:1
			}
		},
        watch: {
            pageType: {
                handler(newValue, oldValue) {
                    this.pageType = newValue;
                    this.getMuBiaoCity();
                }
            },
        },
		beforeCreate() {
		},
		created() {
			this.$nextTick(() => {
				// 禁用右键
				document.oncontextmenu = new Function("event.returnValue=false");
				// 禁用选择
				document.onselectstart = new Function("event.returnValue=false");
			}); 
			this.userdata = this.getuseriformation() || {};
			this.freeTips = !this.userdata.svip;
		},
		mounted() { 
			
			if(this.userdata.city == 0){
				this.pageType = 2;
				this.handlerPageType(2);
			}
			this.getMuBiaoCity();
		},
		methods: {
			handlerClassValue(value){
				if(this.classValue == value){
					return;
				}
				this.classValue = value;
				if(value == 1){
					this.ajaxsearchcompany();
				}else{
					this.enterpristlist = [];
					this.page = 1;
					this.total = 0;
					this.totalPage = 0;

				}
			},
			handlerPageType(type){
				this.pageType = type;
				this.classValue  = 1;
				if(this.pageType == 1){ 
					this.citydata=[];
					this.cityid = '';
					this.countydata=[];
					this.countyid = '';
				}else if(this.pageType == 2){ 
					this.countydata=[];
					this.countyid = '';
				}
			},
            getMuBiaoCity(){
                //后台登录返回的接口里面会有城市id
                let cityId = this.pageType == 1 ? this.userdata.city : this.userdata.province;
                let temData = dataInJs();
                //用城市id匹配城市数据,层级匹配，可能是省也可能是市
				let matchedItem; // 可能是省份或城市

				if (this.pageType == 1) {
					// 情况1：查找城市（city）
					// 遍历每个省份的 children（城市列表），找到匹配 areaId 的城市
					matchedItem = temData
						.flatMap(province => province.children || []) // 扁平化为城市数组
						.find(city => city.areaId === cityId);
					this.countydata = matchedItem.children || [];
					// this.citychoose(this.countydata[0],3);
				} else {
					// 情况2：查找省份（province）
					// 直接在省份列表中查找匹配 areaId 的省份
					console.log('matchedItem',matchedItem);
					matchedItem = temData.find(province => province.areaId === cityId);
					this.citydata = matchedItem.children || [];
					// this.citychoose(this.citydata[0],2);
				}
                
                // this.citychoose(this.citydata,2);
                console.log('citydata',cityId,matchedItem);
				this.ajaxsearchcompany();
            },
            //省份城市选择
			cityScreenFun(pid,cid,cuid){
				if(this.freeTips){
					this.isShowFreeUserTips = true;
					return;
				}
				this.clearNotion();
				this.targetcityid = cid;
				this.targetcountyid = cuid; 
				this.targetprovinceid = pid;
				this.ajaxsearchcompany(1, 'sort');
			},
			citychoose(item,step){
				if(this.freeTips){
					this.isShowFreeUserTips = true;
					return;
				}
                // if(!item.children) return;
				console.log('citychoose',item,step);
				if(step == 2){
					this.cityid=item.areaId;
					this.countydata = item.children || [];
					this.countyid = 0;
				}
				if(step == 3){
					this.countyid=item.areaId;
				}
				this.ajaxsearchcompany();
			},
			//企业列表导出数据
			enlistExport() {
				if (this.exportbtn) {
					this.exportpop = true;
				} 
			},
			//时间/分数升降序
			tablesort(field) {
				if(!this.userdata.token){
					this.isShowFreeUserTips = true;
					return;
				}
				if (field == this.orderField) {
					this.ordertype = Math.abs(this.ordertype - 1);
				} else {
					this.orderField = field;
				}
				this.ajaxsearchcompany();
			},
			searchenter(e) {
				if (e.keyCode == 13) {
					this.searchkwfun();
				}
			},
 
			pageHandler: function(page) {
				if(this.freeTips){
					this.isShowFreeUserTips = true;
					return;
				}
				this.ajaxsearchcompany(page, 'sort', 'search');
			},			//清空概念选项
			clearNotion() {
				this.notionNumRefresh++;
				this.isClearNotion=true; 
				this.notionCode = 0;
			},
			//概念单选 层级显示
			chooseNotion(chooseNotionlist,notionCode,step){ 
				if(this.freeTips){
					this.isShowFreeUserTips = true;
					return;
				}
				this.notionCode=notionCode;  
				if(step){
					this.notionstep = step; 
				}
				var sortStr =  (step && step < 3) ? 'sort':''; 
				if(step && step < 3){
					sortStr = 'sort';
				}else if(step && step <4 && this.isIntegration){
					if(this.notionCode.indexOf('B')>-1||this.notionCode.indexOf('D')>-1||this.notionCode.indexOf('E')>-1||this.notionCode.indexOf('F')>-1){
						sortStr = 'sort';
					}
				}
				this.ajaxsearchcompany(1,sortStr); 
			},
			
			ajaxsearchcompany(pages, citytype, searchtype) {
				if(this.classValue != 1){
					this.enterpristlist = [];
					this.page = 1;
					this.total = 0;
					this.totalPage = 0;
					return;
				}
				console.log('搜索企业',pages, citytype, searchtype);
				this.bus.$emit('loading', true);
				this.page = pages ? pages : 1;
				var _this = this; 
				let ajaxurl = this.$api.cyl.investclue.localWorthy();
				let cityJax = this.pageType == 1 ? this.splicing('city', this.userdata.city) : this.splicing('city', this.cityid);
				let countyJax = this.splicing('county', this.countyid);
				let targetProvinceJax = this.splicing('targetProvince', this.targetprovinceid);
				let targetCityJax = this.splicing('targetCity', this.targetcityid);
				let targetCountyJax = this.splicing('targetCounty', this.targetcountyid);
				let notionJax = this.splicing('notion', this.notionCode);
				let tagJax = this.splicing('tag', this.tagCode);
				let searchJax = this.splicing('kw', this.searchtext);
				ajaxurl = ajaxurl + '?page=' + this.page + cityJax + countyJax + targetProvinceJax + targetCityJax + targetCountyJax + notionJax + tagJax + searchJax;
				// var calcnc = this.notionstep ? '&notionCode=' + this.notionCode : '';
				// var notionstepd = this.notionstep;
				// var ajaxurl = this.getajaxUrl(this.$api.cyl.enterprise.list(), searchtype) + '&page=' + this.page + calcnc;
				console.log(ajaxurl)
				// return;
				this.$axios.get(ajaxurl, {
					headers: {
						AuthToken: this.userdata.token
					}
				}).then(function(res) {
					console.log('企业列表',ajaxurl, res.data);
					if (res.data.success) {
						var dataenterlist = res.data.list;
						// _this.exportnum = res.data.extend.exportRemainder;
						// _this.allowexport = res.data.extend.allowExport;
						// if(isnotiontoggle){
						// 	_this.isClearNotion=false;
						// 	_this.notionNumRefresh++;
						// 	_this.notionNumList=res.data.extend.cityNotionList;  
						// }
						for (var i = 0; i < res.data.list.length; i++) {
							dataenterlist[i].taglist = _this.taglistfun(dataenterlist[i].tag, dataenterlist[i]
								.tagCode);
							if (_this.freeTips && dataenterlist[i].name && dataenterlist[i].name.length > 1) {
								dataenterlist[i].name = dataenterlist[i].name.substring(0, 1) + "*";
							}
						}
						_this.totalPage = res.data.totalPage;
						_this.pageSize = res.data.pageSize;
						_this.total = res.data.totalRecord;
						_this.haspage = res.data.list.length == res.data.pageSize;
						_this.kwtextsearch = _this.searchtext != "";
						_this.kwtextsearchtext = _this.searchtext;
						_this.exportbtn = true;
						_this.confirmtext = "确认导出";
						_this.enterpristlist = _this.freeTips ? dataenterlist.slice(0, 3) : dataenterlist;
						_this.bus.$emit('loading', false);
						 
					}  
				}).catch(function(error) {});
				// console.log(datas);  
			},
			//  
		}
	}
</script>

<style lang="scss">
.gray-font {
	color: #999;
	font-size: 18px;
	cursor: pointer;
	&:hover {
		color: #333;
	}
}
</style>